import React from "react";
import {Text} from "@mantine/core";

import type {Solution} from "../solutions";
import {featuresCards} from "../features-cards";
import {generateRandomPastDates} from "../utils";

import {IconCar} from "@tabler/icons-react";

import {shades} from "@fig/libs/client/styles/js/colors";

const expenseDates = generateRandomPastDates(4);

export const rideSharing: Solution = {
  name: "Ride Sharing",
  description: "More than rides, you're saving on every route.",
  icon: IconCar,
  hero: {
    head: (
      <span>
        A new way for drivers to{" "}
        <Text component="span" c={shades.blue[6]} inherit>
          plan for taxes and save for retirement
        </Text>
      </span>
    ),
    deck: "We'll automate your finances, so you can get back in the fast lane.",
    primaryButton: {
      //onClick: "",
      text: "Join the Waitlist",
    },
    imageSrc: "/assets/www/solutions/ride-sharing/hero.png",
    //bullets: [],
    imageBullets: [
      {
        iconSrc: "/assets/www/home/chat.png",
        text: (
          <span>
            Chat with your{" "}
            <Text component="span" c={shades.blue[6]} inherit fw={500}>
              financial advisor
            </Text>
          </span>
        ),
      },
      {
        iconSrc: "/assets/www/home/piggy-bank.png",
        text: (
          <span>
            Contribute to your{" "}
            <Text component="span" c={shades.blue[6]} inherit fw={500}>
              retirement
            </Text>
          </span>
        ),
      },
      {
        iconSrc: "/assets/www/home/coins-percent.png",
        text: (
          <span>
            Save for your{" "}
            <Text component="span" c={shades.blue[6]} inherit fw={500}>
              taxes
            </Text>
          </span>
        ),
      },
    ],
  },
  savings: {
    head: (
      <span>
        Stay on track to{" "}
        <Text component="span" c={shades.blue[6]} inherit>
          save
        </Text>
      </span>
    ),
    deck: "We automatically track your income and expenses to create a savings plan based on your goals.",
    imageSrc: "/assets/www/solutions/ride-sharing/savings.png",
    income: "7890.00",
    expenses: "2871.09",
    contribution: "500.00",
  },
  advisor: {
    head: (
      <span>
        You're not alone. Dedicated advisors help you{" "}
        <Text component="span" c={shades.blue[6]} inherit>
          achieve your goals
        </Text>
        .
      </span>
    ),
    deck: "Comprehensive financial planning with direct access to registered advisors, on your schedule.",
    imageSrc: "/assets/www/solutions/ride-sharing/chat.png",
    chat: {
      messages: ["How much should I be saving for retirement?", "Have I set enough money aside for taxes this year?"],
      advisor: {
        name: "Kelly M.",
        title: "Her advisor",
        avatarSrc: "/assets/www/home/advisor.png",
      },
      button: {
        //onClick: "",
        text: "Join the Waitlist",
      },
    },
  },
  expenses: {
    head: "Receipts are a pain",
    deck: (
      <span>You've got enough to worry about between fares. Let Fig keep tabs of your spending and deductions.</span>
    ),
    imageSrc: "/assets/www/solutions/ride-sharing/expenses.png",
    transactions: [
      {
        brandImageSrc: "/assets/www/solutions/ride-sharing/brands/exxon.png",
        brandName: "Exxon",
        price: "63.17",
        date: expenseDates[0],
        category: "Gas Station",
      },
      {
        brandImageSrc: "/assets/www/solutions/ride-sharing/brands/stopshop.png",
        brandName: "Stop & Shop",
        price: "31.89",
        date: expenseDates[1],
        category: "Transportation",
      },
      {
        brandImageSrc: "/assets/www/solutions/ride-sharing/brands/geico.png",
        brandName: "Geico",
        price: "219.32",
        date: expenseDates[2],
        category: "Insurance",
      },
      {
        brandImageSrc: "/assets/www/solutions/ride-sharing/brands/garmin.png",
        brandName: "Garmin",
        price: "106.98",
        date: expenseDates[3],
        category: "Software",
      },
    ],
  },
  features: {
    head: "You're covered on all fronts",
    deck: "Choose one service, choose them all. It's totally up to you.",
    cards: featuresCards,
  },
  callToAction: {
    head: "Take the guesswork out of financial planning",
    //deck: "",
    primaryButton: {
      //onClick: "",
      text: "Join the Waitlist",
    },
  },
};
